import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API = `${process.env.VUE_APP_API_URL}crm/deals-dashboard`;

export default {
  get(params = {}) {
    return axios.get(API, { params, headers: buildHeaders() });
  },

  meta() {
    return axios.get(`${API}/meta`, { headers: buildHeaders() });
  },

  exportPdf(params = {}) {
    return axios.get(`${API}/export/pdf`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportExcel(params = {}) {
    return axios.get(`${API}/export/excel`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
